<!--Header responsible for arrows-->
<app-generic-header
  [goBack]="saveChangesButton ? saveButton.bind(this) : exitButton.bind(this)"
  [variant]="
  firstSetup
    ? 'empty'
    : (saveChangesButton ? 'save' : 'back')
">
</app-generic-header>


<ion-content class="ion-padding">

  <div class="centralized">
    
    <div class="page-image">
      <ion-icon src="/assets/imgs/custom-svg/padronized-sizes/heart.svg"></ion-icon>
    </div>

    <div class="page-name">
      {{'interestedIn' | translate}}
    </div>

    <div class="button-list">
          <ion-button value= "female"
          [attr.fill]="hasOption('female') ? 'solid' : 'outline'"
          size="small"
          shape="round" 
          [ngClass]="{ 'unselected': hasOption('female') !== true }"
          (click)="setNewOption('female')">
          {{'women' | translate}}
        </ion-button>

        <ion-button value= "male"
        [attr.fill]="hasOption('male') ? 'solid' : 'outline'"
        size="small"
        shape="round" 
        [ngClass]="{ 'unselected': hasOption('male') !== true }"
        (click)="setNewOption('male')">
        {{'men' | translate}}
      </ion-button>

      <ion-button value= "other"
      [attr.fill]="hasOption('other') ? 'solid' : 'outline'"
      size="small"
      shape="round" 
      [ngClass]="{ 'unselected': hasOption('other') !== true }"
      (click)="setNewOption('other')">
      {{'nonBinaryGenderDiverse' | translate}}
    </ion-button>      
    </div>

    <div class="next-buttons"  [hidden] = "userData?.interest2 === null">
      <ion-button fill="outline" mode= "md" class="back-button" (click)="backButton()" size="small" value="back"  shape="round">{{ 'backSurvey' | translate }}</ion-button>

      <ion-button mode= "md" (click)="nextButton()" size="small" value="next" shape="round">{{ 'nextSurvey' | translate }}</ion-button>
    </div>
  </div>

</ion-content>